/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourcesharelink3Inputs */

const en_summarysourcesharelink3 = /** @type {(inputs: Summarysourcesharelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your share links`)
};

const de_summarysourcesharelink3 = /** @type {(inputs: Summarysourcesharelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Teilen-Links`)
};

/**
* | output |
* | --- |
* | "Your share links" |
*
* @param {Summarysourcesharelink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourcesharelink3 = /** @type {((inputs?: Summarysourcesharelink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourcesharelink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourcesharelink3(inputs)
	return de_summarysourcesharelink3(inputs)
});
export { summarysourcesharelink3 as "summarySourceShareLink" }